import { ReactTFC } from "../../utils/fp/missing-ts-parts";
import { NonEmptyArray } from "fp-ts/es6/NonEmptyArray";
import { DownloadsCarouselElem } from "@swo/storefront";
import { css } from "@emotion/react";
import { CSS_MQ } from "../../styles/breakpoints";
import { mimeToLabel } from "../../utils/formatting/mime-to-label";
import { formattedFileSizeInMegabytes } from "../../utils/formatting/downloads-size-in-megabytes";
import { FONTS, fontSize } from "../../styles/fonts";
import React from "react";
import { CSS_COLORS } from "../../styles/styles-css-variables";
import { DownloadSvg } from "../../assets";

export const PDPDownloadElements: ReactTFC<{ elements: NonEmptyArray<DownloadsCarouselElem> }> = props => {
  return (
    <div
      css={css`
        display: grid;
        gap: 20px 12px;

        ${CSS_MQ.atLeastSm} {
          grid-template-columns: repeat(2, minmax(0, 1fr));
        }

        ${CSS_MQ.atLeastLg} {
          display: flex;
          gap: 30px 40px;
          flex-direction: row;
          flex-wrap: wrap;
        }
      `}
    >
      {props.elements.map(e => {
        const fileTypeLabel = mimeToLabel(e.fileType).toUpperCase();
        const sizeInMB = formattedFileSizeInMegabytes(e.fileSize);
        const sizeLabel = `(${fileTypeLabel} ${sizeInMB} MB)`;

        return (
          <div
            key={e.link}
            css={css`
              display: flex;
              gap: 20px;
            `}
          >
            <a href={e.link} download target="_blank" rel="noopener noreferrer" className={"d-flex"}>
              <DownloadSvg css={iconStyles} />
            </a>

            <div>
              <a
                href={e.link}
                download
                target="_blank"
                rel="noopener noreferrer"
                className={"u-no-decoration u-color-inherit"}
              >
                <span css={descriptionStyles} title={e.description || undefined}>
                  {e.description || e.title}
                </span>
              </a>

              <span css={[fontSize.x2, FONTS.SwarovskiFutura300]}>{sizeLabel}</span>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export const iconStyles = css`
  width: 32px;
  height: 32px;

  color: ${CSS_COLORS.Black};
`;

export const descriptionStyles = [
  fontSize.x2,
  FONTS.SwarovskiFutura300,
  css`
    display: -webkit-box;
    -webkit-box-pack: end;
    -moz-webkit-box-pack: end;
    justify-self: center;

    /* multi line ellipsis */
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    -moz-webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
  `,
];
